const RoadMapItem = ({ progressIcon, progress, title, text1, text2, text3, text4, thumb, text }) => {
  return (
    <div className="bithu_roadmap_item"> 
      <div className="roadmap_parcentage">
        <span>{progress}</span>
        <span className="parcentage">%</span>
      </div> 
      <div className="bithu_roadmap_content"> 
        <div className="bithu_roadmap_text">
          <div className="roadmap_heading">
            <h5 className="mb-15"> {title} </h5>
            {/* {progressIcon} */}
            <img src={progressIcon} alt={"ALPHA OCTOPUS nft progress"} />
          </div>
          <p>{text}</p>
          {/* <ul>
            <li>{text1}</li>
            <li>{text2}</li>
            <li>{text3}</li>
            <li>{text4}</li>
          </ul> */}
        </div>
      </div>
      <div className="roadmap_img">
        <img src={thumb} alt="ALPHA OCTOPUS nft progress" />
      </div>
    </div>
  );
};

export default RoadMapItem;
